/**
 * Same concept as {@link Array.map}, but for objects
 *
 * @example
 * const original = {
 *   a: "1",
 *   b: "2",
 *   c: "3"
 * }
 * const result = mapProperties(original, (val, k, _original) => Number(val))
 * console.log(result) // { a: 1, b: 2, c: 3 }
 */
export function mapProperties<T, U>(
  obj: T,
  map: (
    val: IndexUnion<T, Key.In.Union<T>>,
    key: Key.In.Union<T>,
    obj: T,
  ) => Coalesce<
    IndexUnion<U, Extract<Key.In.Union<U>, Key.In.Union<T>>>,
    undefined
  >,
): U
export function mapProperties<T, P>(
  obj: T,
  map: (val: IndexUnion<T>, key: Key.In.Union<T>, obj: T) => P,
): T extends any ? Record<keyof T, P> : never
export function mapProperties(
  obj: unknown,
  map: (val: unknown, key: keyof any, obj: unknown) => unknown,
): unknown {
  if (!obj) {
    return obj
  }
  const result: Unknown.ButNotNullish = {}
  for (const k in obj) {
    result[k] = map(obj[k as keyof typeof obj], k, obj) as Unknown
  }
  return result
}
